import React, { useState } from 'react';
import { Modal, Button, Form, FloatingLabel, Row, Col } from 'react-bootstrap';

const OnboardingDocumentRequestModal = ({ show, onHide, onSubmit, packageId = null }) => {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    category: '',
    requiredFileTypes: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Use custom file types if "custom" is selected, otherwise use the selected value
    const finalFileTypes = formData.requiredFileTypes === 'custom' 
      ? formData.customFileTypes 
      : formData.requiredFileTypes;
    
    onSubmit({
      ...formData,
      requiredFileTypes: finalFileTypes,
      packageId
    });
    setFormData({ title: '', description: '', category: '', requiredFileTypes: '', customFileTypes: '' });
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton className="border-0 px-md-4">
        <div className="d-flex flex-column gap-2 w-100">
          <Modal.Title>Create Document Request</Modal.Title>
          <div className="text-hl"></div>
        </div>
      </Modal.Header>
      <Modal.Body className="px-md-4">
        <div className="alert alert-info mb-3">
          <div className="d-flex align-items-start">
            <i className="bi bi-info-circle-fill me-2 mt-1"></i>
            <div>
              <strong>Create Document Request</strong>
              <p className="mb-0 small">Document requests ask residents to upload specific files. You can specify what types of files are required (PDF, images, etc.) and provide instructions. Residents will be prompted to upload the requested documents when assigned.</p>
            </div>
          </div>
        </div>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={12}>
          <Form.Group className="mb-3">
            <FloatingLabel controlId="floatingInput" label="Title" className="mb-3 required-field">
            <Form.Control
              type="text"
              value={formData.title}
              onChange={(e) => handleChange('title', e.target.value)}
              placeholder="Enter document title"
              required
            />
            </FloatingLabel>
          </Form.Group>
          </Col>
          <Col md={6}>
          <Form.Group className="mb-3">
            <FloatingLabel controlId="floatingInput" label="Category" className="mb-3">
            <Form.Control
              type="text"
              value={formData.category}
              onChange={(e) => handleChange('category', e.target.value)}
              placeholder="e.g., Medical Records, Certifications, etc."
            />
            </FloatingLabel>
          </Form.Group>
          </Col>
          <Col md={6}>
          <Form.Group className="mb-3">
            <FloatingLabel controlId="floatingFileTypes" label="Required File Types" className="mb-3">
              <Form.Select
                value={formData.requiredFileTypes}
                onChange={(e) => handleChange('requiredFileTypes', e.target.value)}
              >
                <option value="">All file types</option>
                <option value="pdf">PDF files only</option>
                <option value="doc,docx">Word documents</option>
                <option value="pdf,doc,docx">PDF and Word documents</option>
                <option value="jpg,jpeg,png">Image files</option>
                <option value="pdf,jpg,jpeg,png">PDF and Image files</option>
                <option value="custom">Custom file types...</option>
              </Form.Select>
            </FloatingLabel>
             </Form.Group>
            
            
         
          </Col>
          {formData.requiredFileTypes === 'custom' && (
              <Col md={12}>
                <Form.Group className="mb-2">
              <FloatingLabel controlId="floatingCustomFileTypes" label="Custom File Types" className="mb-3">
                <Form.Control
                  type="text"
                  value={formData.customFileTypes || ''}
                  onChange={(e) => handleChange('customFileTypes', e.target.value)}
                  placeholder="e.g., pdf,doc,docx,xlsx"
                />
                <Form.Text className="text-muted">
                  Comma-separated list of file extensions (without dots)
                </Form.Text>
              </FloatingLabel>
              </Form.Group>
              </Col>
            )}
          <Col md={12}>
          <Form.Group className="mb-3">
            <FloatingLabel controlId="floatingTextarea" label="Description">
            <Form.Control
              as="textarea"
              value={formData.description}
              onChange={(e) => handleChange('description', e.target.value)}
              placeholder="Describe what document is needed"
              style={{ height: '100px' }}
            />
            </FloatingLabel>
          </Form.Group>
          </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer className="border-0 px-md-4">
        <Button variant="secondary" size="sm" onClick={onHide}>Cancel</Button>
        <Button variant="primary" size="sm" onClick={handleSubmit} disabled={!formData.title.trim()}>
          Create Request
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default OnboardingDocumentRequestModal;
